import { Pipe, PipeTransform } from '@angular/core';
import { FormArray } from '@angular/forms';

@Pipe({ name: 'isMismatch', pure: false })

export class MismatchPipe implements PipeTransform {

  transform(index: number, fieldName: string, formArray: FormArray): boolean {
    if (index === 0 || !formArray || formArray.length === 0) {
      return false;
    }

    const firstValue = formArray.at(0).get(fieldName)?.value;
    const currentValue = formArray.at(index).get(fieldName)?.value;

    if (this.isEmpty(firstValue) || this.isEmpty(currentValue)) {
      return false;
    }

    return firstValue !== currentValue;
  }

  private isEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
  }
}